import { FC } from "react";
import { Box, Typography } from "@mui/material";
import vectorIcon from "../../assets/icons/Vector.svg";
import InfoIconYellow from "../../assets/icons/information.svg";
import { Colors } from "../../styles/constant";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { T_NudgeBannerData } from "../../features/Features_Cms/CmsGlobal.Types";

interface Props {
  nudgeData: T_NudgeBannerData | null;
  initialUrl: string;
  isChangesForLifeInsurance: boolean;
  withInfoText: string | null;
  handleNudgeClick: any;
}
const CustomNudge: FC<Props> = ({
  nudgeData,
  initialUrl,
  isChangesForLifeInsurance,
  withInfoText,
  handleNudgeClick,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "1rem",
        backgroundColor: "#FFF4CE",
        borderRadius: "1rem",
        padding: "0.563rem",
      }}
    >
      {nudgeData?.attributes?.infographic?.data &&
      nudgeData?.attributes?.infographic?.data?.attributes?.url ? (
        <img src={initialUrl} alt="" style={{ marginRight: ".5rem" }} />
      ) : (
        <img
          alt=""
          src={isChangesForLifeInsurance ? vectorIcon : InfoIconYellow}
          style={{ marginRight: ".5rem" }}
        />
      )}

      <Typography
        textAlign={isChangesForLifeInsurance ? "left" : "center"}
        variant="h6"
        color={withInfoText ? Colors.textGray : Colors.iconYellow}
      >
        {withInfoText || nudgeData?.attributes.title
          ? (nudgeData?.attributes.title ?? withInfoText)
          : `Your changes will reflect in 3 days.`}
      </Typography>

      <Box marginLeft="auto" display="flex" alignItems="center">
        <KeyboardArrowRightIcon
          fontSize="small"
          sx={{ color: Colors.red }}
          onClick={handleNudgeClick}
        />
      </Box>
    </Box>
  );
};

export default CustomNudge;
